import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import RestoreIcon from "@mui/icons-material/Restore";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { convertDate } from "../../components/helperFunctions";

export default function ProductModelCard({
    product,
    viewHistory = false,
    onViewHistory,
}) {
    const [dialogProps, setDialogProps] = useState({});

    useEffect(()=>{
        if (product) {
            setDialogProps({
                docId: product._id,
                docType: "products",
                title: `${product.serialNumber} Change History`,
            })
        }
    },[product]);

    return (
        <Card sx={{ width: "100%", overflow: "visible", height: "100%" }}>
            <MDBox p={3}>
                <MDBox display="flex" justifyContent="space-between">
                    <MDBox>
                        <MDTypography variant="h4">
                            Product Details:
                        </MDTypography>
                    </MDBox>

                    {viewHistory && (
                        <MDBox>
                            <Tooltip title="View Change History">
                                <IconButton
                                    onClick={() => onViewHistory(dialogProps)}
                                >
                                    <RestoreIcon />
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    )}
                </MDBox>
                <MDBox mt={2} sx={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>

                        <tbody>
                            <tr>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Serial Number
                                    </MDTypography>
                                </td>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="regular">
                                        {product?.serialNumber || "N/A"}
                                    </MDTypography>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Mac Address
                                    </MDTypography>
                                </td>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="regular">
                                        {product?.macAddress || "N/A"}
                                    </MDTypography>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Firmware Version
                                    </MDTypography>
                                </td>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="regular">
                                        v{product?.firmwareVersion || "N/A"}
                                    </MDTypography>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Battery Capacity
                                    </MDTypography>
                                </td>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="regular">
                                        {product?.batteryCapacity || "N/A"}
                                    </MDTypography>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Shelf Life
                                    </MDTypography>
                                </td>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="regular">
                                        {`${product?.shelfLife[0]} ${product?.shelfLife[1]}` || "N/A"}
                                    </MDTypography>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Date of Storage
                                    </MDTypography>
                                </td>
                                <td style={{ padding: "6px", borderBottom: "1px solid #f0f0f0" }}>
                                    <MDTypography variant="h6" fontWeight="regular">
                                        {convertDate(product?.dateOfStorage) || "N/A"}
                                    </MDTypography>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: "6px" }}>
                                    <MDTypography variant="h6" fontWeight="medium">
                                        Price
                                    </MDTypography>
                                </td>
                                <td style={{ padding: "6px" }}>
                                    <MDTypography variant="h6" fontWeight="regular">
                                        ${product?.price || "N/A"}
                                    </MDTypography>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </MDBox>
            </MDBox>
        </Card>
    )
}
